import React from "react";
import { useTranslation } from "react-i18next";
import appConfig from "../../../../../config";

function CAD({ result }) {
  const { t } = useTranslation();
  const text = appConfig.isLoggedIn ? t("2D-3D LINK") : t(appConfig.loginText);
  const link = appConfig.isLoggedIn
    ? result["cad_link"].raw
    : result["cad_link"].raw
    ? appConfig.loginLink
    : "";
  return (
    <td>
      {link && (
        <a href={link} target="_blank">
          {text}
        </a>
      )}
    </td>
  );
}
export default CAD;
